import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from "@angular/material";
import { CustomerDetailComponent } from '../customer-detail/customer-detail.component';
import { RefundOrderComponent } from '../refund-order/refund-order.component';
import { CustomerNotificationComponent } from '../customer-notification/customer-notification.component';

import { environment } from '../../../environments/environment';
import { FlashMessagesService } from "angular2-flash-messages";

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css']
})
export class CustomerListComponent implements OnInit {
  public loading = false;
  public customerList: Array<any> = [];
  public Options: any = {};
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public limit = 10;
  public search: string = "";
  public sortColumnName = "id";
  public sortDirection = "desc";
  public filterText: string;
  public storeId: string;
  public csvUrl: string;
  public locationArr = [
    'front',
    'back',
    'left',
    'right'
  ];
  shipmentData: Array<any>=[];
  storeData: Array<any>=[];
  userData: Array<any>=[];
  storeStatus: string = '';
  public boxLabel = true;

  constructor(private CommonService: CommonService,
    private router: Router,
    private activateroute: ActivatedRoute,
    public dialog: MatDialog,
    private _flashMessagesService: FlashMessagesService
  ) { }

  ngOnInit() {
    this.storeId = this.activateroute.snapshot.params["storeId"];
    this.csvUrl = environment.API_URL + "/exportcsv/" + localStorage.getItem("userID") + "/" + this.storeId;
    this.getStoreCustomerData();
    this.getPrintLabelData();
  }
  exportToCSV = function () {
    //this.loading = true;
    this.Options = {
      id: localStorage.getItem("userID"),
      store_id: this.storeId
    };
    this.CommonService.apiService(
      "POST",
      "clientorder/export",
      this.Options
    ).subscribe(
      (response: any) => {
        // if (response.status === true) {
        //   this.loading = false;
        //   if (response.data) {

        //   }
        // }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  getStoreCustomerData = function () {
    this.loading = true;
    this.Options = {
      id: localStorage.getItem("userID"),
      limit: this.limit,
      page: this.page,
      store_id: this.storeId
    };
    if (this.filterText) {
      this.Options.search = this.filterText;
    }

    // if (this.sortDirection) {
    //   this.Options.orderBy = this.sortColumnName;
    //   this.Options.direction = this.sortDirection;
    // }
    this.CommonService.apiService(
      "POST",
      "store/clients",
      this.Options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (response.data) {
            this.customerList = response.data.records;//.filter(x=>x.purchase_date!=null);  
            this.total = response.data.total;
            this.current_page = response.data.current_page;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  //Assign a product-image when mockup is not available
  getMockupImage(list: any, orderIndex: any, order: any){
    let imageUrl: string = '';
    if(list){
      if(list.mockup_data){
        if(list.mockup_data[orderIndex]){
          if(list.mockup_data[orderIndex]['front']){
            if(list.mockup_data[orderIndex]['front'].mockup){
              imageUrl = list.mockup_data[orderIndex]['front'].mockup;
            }
          }
        }
        if (!imageUrl) {
          if (list.mockup_data[0][Object.keys(list.mockup_data[0])[0]].mockup) {
            imageUrl = list.mockup_data[0][Object.keys(list.mockup_data[0])[0]].mockup;
          }
        }
      }
    }
    if(!imageUrl){
      if(order){
        if(order.product[0]){
          if(order.product[0].image){
            imageUrl = order.product[0].image;
          }
        }
      }
    }
    return imageUrl;
  }

  trackByFn(index: any, item: any) {
    return index;
  }
  backToList() {
    this.router.navigate(['/stores']);
  }
  openAddressDialog(orderId) {
    let customerData = this.customerList.find(x => x.customer_order_id == orderId);    
    const dialogRef = this.dialog.open(CustomerDetailComponent, {
      width: "500px",
      disableClose: true,
      data: {
        customerData: customerData
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      // if (result == "success") {

      // }
    });
  }

  openRefundDialog(orderId) {
    let tempOrderData = this.customerList.find(x => x.customer_order_id == orderId);
    let orderData = JSON.parse(JSON.stringify(tempOrderData));    
    orderData.order_data.forEach((pvalue, pkey) => {
      pvalue.product[0].currentQty = [...pvalue.product[0].quantity];
      pvalue.product[0].quantity= [...pvalue.product[0].quantity];
    });    
    const dialogRef = this.dialog.open(RefundOrderComponent, {
      width: "500px",
      disableClose: true,
      data: {
        orderData: orderData
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.getStoreCustomerData();
      }
    });
  }

  goToPage(n: number): void {
    this.page = n;
    this.getStoreCustomerData();
  }

  onNext(): void {
    this.page++;
    this.getStoreCustomerData();
  }

  onPrev(): void {
    this.page--;
    this.getStoreCustomerData();
  }

  openCustomerNotificationDialog(orderId: string = null): void {
    const storeId = this.customerList.length > 0 ? this.customerList[0].store_id : null;
    const dialogRef = this.dialog.open(CustomerNotificationComponent, {
      width: "500px",
      data: {
        storeId: storeId,
        orderId: orderId
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  refundOrderItem = function (listIndex, orderIndex, type = 'item') {
    this.loading = true;
    const orderItem = this.customerList[listIndex];
    if (orderItem) {
      let refundTotalQty = 0;
      let refundTotalPrice = 0;

      orderItem.order_data.forEach((pvalue, pkey) => {
        if (pkey == orderIndex) {
          orderItem.order_data[orderIndex].product[0].currentQty = orderItem.order_data[orderIndex].product[0].quantity;
          pvalue.product.forEach((productValue, productKey) => {
            productValue.size.forEach((sizeValue, sizeKey) => {
              orderItem.order_data[pkey].product[productKey].size[sizeKey].refunded = true;
              const quantity = parseFloat(orderItem.order_data[orderIndex].product[0].quantity[sizeKey]);
              const price = parseFloat(orderItem.order_data[orderIndex].product[0].retail_price);
              refundTotalQty += quantity;
              refundTotalPrice += quantity * price;
            });
          });
        }
      });

      orderItem.refundTotalQty = refundTotalQty;
      orderItem.refundTotalPrice = refundTotalPrice;
      orderItem.refundTax = 0;
      orderItem.refundShippingPrice = 0;
      orderItem.refundGrandTotalPrice = refundTotalPrice;
    }

    let options = {
      id: localStorage.getItem("userID"),
      invoice_id: orderItem.customer_order_id,
      refund_data: orderItem,
      refundType: type
    }
    this.CommonService.apiService(
      "POST",
      "store/refund",
      options
    ).subscribe(
      (response: any) => {
        this.loading = false;
        this.getStoreCustomerData();
        
        if (response.status === true) {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 4000
          });
        } else {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-warning",
            timeout: 3000
          });
        }
      },
      err => {
        this.loading = false;
        console.log(err);
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
      }
    );
  }

  confirmRefund(listIndex, orderIndex, type = 'item') {
    const userConfirmed = confirm('Do you want to refund this item in order?');
    if (userConfirmed) {
      this.refundOrderItem(listIndex, orderIndex, type);
    }
  }

  getPrintLabelData = function () {
    let printOptions = {
      id: localStorage.getItem("userID"),
      store_id: this.storeId
    }

    this.CommonService.apiService(
      "POST",
      "store/printLabels",
      printOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
         this.shipmentData = response.data.labels;
         this.storeData = response.data.store;
         this.storeStatus = this.storeData.status;
         this.userData = response.data.user;
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  printLabels(orderId, type = 'labels') {
    let item = [];
    if (type == 'label') {
      item = this.shipmentData.find(data => data.order_id === orderId);
    } else {
      item = [];
    }

    const storeLabelData = {
      labels: type == 'label' ? [item] : this.shipmentData,
      store: this.storeData,
      user: this.userData
    };
    localStorage.setItem('storeLabelData', JSON.stringify(storeLabelData));

    const url = '/stores/shipping-labels/' + this.storeId;
    window.open(url, '_blank');
  }

  printCustomerOrders() {
    const url = '/stores/customer-orders/' + this.storeId;
    window.open(url, '_blank');
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/customer-list/customer-list.component.ts